<script>
// https://bulma.io/documentation/modifiers/typography-helpers/#size
const SIZE_CLASSES = {
    sm: 'is-size-6',
    md: 'is-size-1',
    lg: 'is-size-xl',
}

const sizeClass = ({ pixelSize, size }) => {
    if (pixelSize !== null) {
        return ''
    }
    return {
        class: SIZE_CLASSES[size]
    }
}

const wrapperClass = ({ fullScreen, inline, overlay }) => {
    return {
        class: {
            'is-full-screen': fullScreen,
            'is-inline-flex': inline,
            'is-overlay': overlay
        }
    }
}

const pixelStyle = ({ pixelSize }) => {
    if (pixelSize == null) {
        return {}
    }
    return {
        width: pixelSize + 'px',
        height: pixelSize + 'px',
    }
}

export default {
    name: 'Loader',
    functional: true,
    render (h, ctx) {
        const { props, data } = ctx
        return (
            <div class="loader-wrapper" {...wrapperClass(props)} {...data}>
                <div class="loader" {...sizeClass(props)} style={pixelStyle(props)} />
            </div>
        )
    },
    props: {
        size: {
            type: String,
            default: 'sm',
            validator: size => {
                return Object.keys(SIZE_CLASSES).includes(size)
            }
        }, // Sizes the widget by pixels and overrides sizing by class
        pixelSize: {
            type: Number,
            default: null,
        },
        fullScreen: {
            type: Boolean,
            default: false,
        },
        overlay: {
            type: Boolean,
            default: false,
        },
        inline: {
            type: Boolean,
            default: false,
        }
    }
}
</script>

<style lang="scss">
// setting the "scope" attribute causes a bug??

@mixin loader-mixin($color) {
    border: 2px solid $color;
    border-right-color: transparent;
    border-top-color: transparent;
}
.loader-wrapper {
    @include flex-center-children;
    .loader {
        @include loader-mixin(darkgrey);
        &.is-size-xl {
            font-size: 6rem;
            border-width: 4px;
        }
    }
    &.is-white .loader {
        @include loader-mixin(#fafafa);
    }
    &.is-inline-flex {
        display: inline-flex;
    }
    &.is-full-screen {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        z-index: 99999;
        .loader {
            @include loader-mixin(darkgrey);
            border-width: 4px;
        }
    }
}
</style>
